<template>
  <div>
    <van-popup position="right" :close-on-click-overlay="false" round v-model="show"
               :style="{ width: '90%',backgroundColor:'#eae9e9'}">
      <van-nav-bar title="冲销借款" left-text="取消" right-text="确定" @click-left="close"
                   @click-right="relativeFlowPopupSubmit"/>
      <van-search v-model="queryParams.title" show-action @search="onSearch" clearable shape="round"/>
      <div style="overflow-y: auto" class="h-vh-70">
        <div class="p-10">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished"
                      finished-text="没有更多了" @load="getList"
                      class="p-l-20 p-r-20 p-b-20">
              <div @click="change(item)" v-for="(item,index) in list" :key="index" class="bg-FF p-20 m-t-20 b-r-10"
                   :style="{border: item.activated ? '3px solid #F8B91A' : ''}">
                <div class="flex col-center row-between">
                  <img class="w-52 h-52" :src="`${image_base_url}/zhengxuanlist_icon.png`"></img>
                  <!-- 标题 -->
                  <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
                    {{ item.userName }}
                  </div>
                  <div class="font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7">
                    {{ item.businessNo }}
                  </div>
                </div>
                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">所属部门</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.deptName }}
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">借款时间</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.debtTime ? moment(item.debtTime).format('YYYY-MM-DD hh:mm:ss') : '' }}
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">借款金额</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.debtAmount + ' 元' }}
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">事由</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.debtReason }}
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">已还款金额</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.repayAmount + ' 元' }}
                    </div>
                  </van-col>
                </van-row>

                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">状态</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.state === '1' ? '已完结' : '未完结' }}
                    </div>
                  </van-col>
                </van-row>

              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {queryImprest} from '@/api/flow'
import moment from "moment";
import {mapState} from "vuex";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: String,
    },
  },
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    })
  },
  data() {
    return {
      moment,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      selectdList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        state: '0',
        title: '',
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    close() {
      this.$emit('close')
      this.list.forEach(item => {
        delete item.activated
      })
    },
    change(item) {
      if (item.activated) {
        this.$set(item, 'activated', !item.activated)
      } else {
        this.$set(item, 'activated', true)
      }
      // push到列表中
      if (item.activated) {
        this.selectdList.push(item)
      }
    },
    // 下拉
    onRefresh() {
      this.finished = false;
      this.list = []
      this.queryParams.pageNum = 1
      this.getList();
    },
    relativeFlowPopupSubmit() {
      this.$emit('finish', this.selectdList)
      this.list.forEach(item => {
        delete item.activated
      })
      this.selectdList = []
    },
    onSearch(text) {
      this.queryParams.title = text;
      this.finished = false
      this.queryParams.pageNum = 1;
      this.list = []
      this.getList();
    },
    getList() {
      this.loading = true;
      this.queryParams.groupId = this.groupId ? this.groupId : ''
      queryImprest(this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        if (res.total == res.rows.length) {
          this.finished = true
        }
        this.list = this.list.concat(res.rows)
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;
      }).catch(err => {
        this.error = true
      })
    }
  }
}
</script>
<style lang="less">
.activated {
  border: 1px solid @theme-color;
}
</style>

